class ThemeManager {
	constructor() {
		this.themes = {
			default: {}, // Empty object for default theme (uses Shopify settings)
			halloween: {
				'color-scheme': 'only dark',
				'--black': '277 231 228',
				'--text': '243 231 228',
				'--white': '24 21 41',
				'--primary': '32, 28, 54',
				'--secondary': '8 7 13',
				'--accent': 'var(--collection-color, 244 128 92)',
				'--overlaybackground':
					'linear-gradient(270deg, rgba(var(--accent) / 0.25), rgba(var(--accent) / 0.35) 100%)',
				'--footer-bg': '16, 14, 27',
				'--footer-text': '243 231 228',
			},
			christmas: {
				'--black': '0 71 0', // Dark green
				'--text': '255 255 255',
				'--body-font': '"Roboto", sans-serif',
				'--buttons-font': '"Mountains of Christmas", cursive',
				'--heading-font': '"Mountains of Christmas", cursive',
				'--white': '255 255 255',
				'--primary': '196 30 58', // Christmas red
				'--secondary': '0 128 0', // Green
				'--accent': '212 175 55', // Gold
				'--overlaybackground':
					'linear-gradient(270deg, rgba(212, 175, 55, 0.5), rgba(212, 175, 55, 0.7) 100%)',
			},
		}

		this.loadSavedTheme()
		this.checkUrlForTheme()
	}
	spiderWeb() {}
	applyTheme(themeName) {
		const theme = this.themes[themeName] || this.themes.default
		for (const property in theme) {
			document.documentElement.style.setProperty(
				property,
				theme[property],
			)
		}
		if (themeName === 'default') {
			document.documentElement.removeAttribute('data-theme')
		} else {
			document.documentElement.setAttribute('data-theme', themeName)
		}

		// Set data-theme attribute for dark mode
		document.documentElement.toggleAttribute(
			'data-dark-theme',
			this.isDarkTheme(theme),
		)
		// Apply any additional theme-specific changes
		//this.applySpecialEffects(themeName);
	}
	isDarkTheme(theme) {
		// Check if the theme's background color is dark
		const bgColor = theme['--white'] || theme['--background'] || ''
		const [r, g, b] = bgColor.split(' ').map(Number)

		// Calculate perceived brightness
		// Using the formula: (R * 299 + G * 587 + B * 114) / 1000
		const brightness = (r * 299 + g * 587 + b * 114) / 1000

		// Consider it dark if brightness is less than 128 (half of 255)
		return brightness < 128
	}
	//applySpecialEffects(themeName) {
	//	// Remove any previously added special effects
	//	document.body.classList.remove("halloween-effect", "christmas-effect");

	//	// Apply theme-specific effects
	//	if (themeName !== "default") {
	//		document.body.classList.add(`${themeName}-effect`);
	//	}
	//}

	saveTheme(themeName) {
		localStorage.setItem('shopifyTheme', themeName)
	}

	loadSavedTheme() {
		const savedTheme = localStorage.getItem('shopifyTheme') || 'default'
		this.applyTheme(savedTheme)
	}

	changeTheme(themeName) {
		this.applyTheme(themeName)
		this.saveTheme(themeName)
	}

	addTheme(themeName, themeProperties) {
		this.themes[themeName] = themeProperties
	}

	getThemes() {
		return Object.keys(this.themes)
	}

	getCurrentTheme() {
		return localStorage.getItem('shopifyTheme') || 'default'
	}

	resetToDefault() {
		this.changeTheme('default')
		// Clear all inline styles set by our themes
		const rootStyle = document.documentElement.style
		// biome-ignore lint/complexity/noForEach: <explanation>
		Object.keys(this.themes.halloween).forEach((key) => {
			rootStyle.removeProperty(key)
		})
	}
	checkUrlForTheme() {
		const urlParams = new URLSearchParams(window.location.search)
		const eventParam = urlParams.get('event')
		this.changeTheme(eventParam)
	}
}

// Create an instance and expose it globally
window.themeManager = new ThemeManager()

const runColorMode = (fn) => {
	if (!window.matchMedia) {
		return
	}

	const query = window.matchMedia('(prefers-color-scheme: dark)')

	fn(query.matches)

	query.addEventListener('change', (event) => fn(event.matches))
}
function changeFaviconColor(color, fill) {
	const fillColor =
		fill ?? document.documentElement.style.getPropertyValue('--text')
	const svg = `
				<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="13.5" cy="13.5" r="12" stroke="${
						color ?? 'transparent'
					}" stroke-width="3" stroke-linecap="round"/>
					<path d="M6.58857 0.086814C6.46457 0.285813 5.37159 4.12078 5.42159 4.17078C5.44658 4.19578 5.68258 4.14578 5.94258 4.05878C6.41458 3.89778 6.42758 3.88479 6.78758 2.59379C7.10958 1.4398 7.13457 1.2408 6.99857 0.744801C6.84958 0.160803 6.70057 -0.0871853 6.58857 0.086814Z" fill="${fillColor}"/>
					<path d="M7.86718 0.0369872C7.86718 0.285986 6.71219 3.94797 6.58819 4.05897C6.51319 4.14597 5.6072 4.49399 4.5892 4.85398C2.33021 5.62298 1.4862 6.02099 1.2382 6.38099C0.791206 7.06298 0.890204 8.26697 1.4362 8.77597C1.6102 8.93796 2.21821 9.17395 2.95121 9.35995C3.62121 9.52095 4.2292 9.71997 4.3042 9.79397C4.4162 9.90597 4.19219 11.7809 3.93119 12.8729C3.80719 13.3939 4.21719 13.1829 4.94919 12.3519C5.79318 11.3829 6.0672 11.334 6.5762 12.0039C6.7622 12.2649 6.9362 12.5009 6.9732 12.5379C6.9982 12.5749 7.28319 12.3019 7.60619 11.9289C8.28919 11.1599 8.48716 11.1469 9.02116 11.9169C9.22016 12.1899 9.41818 12.414 9.49318 12.414C9.55518 12.414 9.74117 12.1899 9.91517 11.9169C10.3742 11.1969 10.5352 11.185 11.1442 11.781C11.4292 12.054 11.7022 12.289 11.7642 12.289C11.9132 12.289 11.8762 12.128 10.1882 6.76499C9.33118 4.034 8.50018 1.39001 8.36318 0.894009C8.21418 0.410011 8.04017 0 7.97817 0C7.91617 0 7.86718 0.0119873 7.86718 0.0369872ZM22.7631 14.2139C22.7631 14.5739 23.5571 15.6659 23.9421 15.8519C24.6871 16.1999 24.5881 15.9139 23.6571 14.9829C23.1601 14.4989 22.7631 14.1519 22.7631 14.2139Z" fill="${fillColor}"/>
					<path d="M7.74337 12.2144C7.52037 12.5244 7.24737 12.8104 7.14837 12.8474C6.97437 12.9094 6.13037 12.1155 6.13037 11.8795C6.13037 11.6805 5.90639 11.8425 5.02539 12.6985L4.15638 13.5424L3.92039 15.0944C3.79639 15.9384 3.7344 16.6704 3.7834 16.7084C3.84639 16.7334 4.03239 16.5464 4.21839 16.2614C4.40439 15.9884 4.65238 15.7644 4.77738 15.7644C4.90138 15.7644 5.21138 16.0254 5.45938 16.3484C5.72038 16.6834 5.96837 16.9934 6.01837 17.0554C6.06837 17.1174 6.51438 16.8194 7.01138 16.3974C7.49538 15.9754 7.95437 15.6534 8.04137 15.6774C8.11637 15.7024 8.45137 16.1124 8.77437 16.5844C9.09737 17.0554 9.43237 17.4534 9.51937 17.4654C9.60536 17.4774 9.99035 17.0684 10.3883 16.5594C10.8593 15.9384 11.1824 15.6404 11.3194 15.6654C11.4304 15.6904 11.7904 16.0994 12.1254 16.5714C12.4484 17.0554 12.7834 17.4534 12.8704 17.4654C12.9574 17.4904 13.3054 17.1304 13.6404 16.6834C14.2983 15.8264 14.5714 15.6034 14.8444 15.7154C14.9314 15.7524 15.2783 16.1374 15.6263 16.5714C15.9613 17.0184 16.2963 17.3784 16.3713 17.3784C16.4333 17.3784 16.7933 17.0184 17.1533 16.5714C17.5383 16.1124 17.9103 15.7644 18.0473 15.7644C18.1833 15.7644 18.5183 16.0994 18.9163 16.6334C19.2763 17.1054 19.5743 17.5024 19.5983 17.5024C19.6233 17.5024 20.0203 17.1674 20.4923 16.7574C20.9513 16.3484 21.4233 16.0134 21.5233 16.0134C21.6223 16.0134 22.0813 16.2614 22.5403 16.5714C23.8813 17.4654 23.8943 17.3904 22.9133 15.3924L22.2053 13.9644L17.5503 13.5174C14.9813 13.2694 12.7714 13.0334 12.6104 12.9844C12.4489 12.9242 12.3099 12.8156 12.2123 12.6735C12.1383 12.5245 12.0013 12.4624 11.8153 12.4994C11.6043 12.5374 11.4053 12.4254 11.1083 12.1154C10.8723 11.8664 10.6114 11.6685 10.5364 11.6685C10.4744 11.6685 10.2764 11.8915 10.1024 12.1645C9.61837 12.9465 9.38238 12.9465 8.82338 12.1645C8.62538 11.8915 8.40138 11.6685 8.31438 11.6685C8.22838 11.6685 7.97937 11.9164 7.74337 12.2144Z" fill="${fillColor}"/>
					<path d="M4.50297 16.4116C4.35397 16.6346 4.16694 16.8706 4.08094 16.9456C3.93194 17.0816 3.34797 20.8426 3.45997 20.9546C3.49697 20.9916 3.74497 20.8186 3.99397 20.5696C4.30397 20.2596 4.53994 20.1226 4.67594 20.1856C4.78794 20.2226 5.09795 20.5576 5.38395 20.9296C5.65695 21.3026 5.91797 21.6006 5.94297 21.6006C5.97997 21.6006 6.36495 21.2656 6.82394 20.8556C7.27094 20.4456 7.69294 20.1106 7.75494 20.1106C7.81694 20.1106 8.10293 20.3216 8.39993 20.5826C9.39392 21.4636 9.25692 21.4516 10.1759 20.7436C10.6349 20.3966 11.0569 20.1106 11.1189 20.1106C11.1689 20.1106 11.4539 20.3216 11.7519 20.5826C12.7329 21.4636 12.6209 21.4386 13.4779 20.8056C13.8999 20.4956 14.3339 20.2346 14.4459 20.2346C14.5579 20.2346 14.8679 20.4586 15.1289 20.7316C15.3889 21.0046 15.6749 21.2276 15.7489 21.2276C15.8239 21.2276 16.2209 20.9796 16.6309 20.6696C17.0279 20.3716 17.4499 20.1106 17.5619 20.1106C17.6729 20.1106 17.9839 20.3836 18.2439 20.7316C18.5049 21.0666 18.7409 21.3516 18.7779 21.3516C18.8029 21.3516 19.1009 21.1036 19.4239 20.7936C19.7469 20.4826 20.0939 20.2346 20.1809 20.2346C20.2679 20.2346 20.6649 20.5206 21.0619 20.8556C21.4599 21.2026 21.8319 21.4766 21.8819 21.4766C21.9309 21.4766 22.2419 21.2026 22.5769 20.8556C22.9119 20.5076 23.2599 20.2346 23.3589 20.2346C23.4459 20.2346 23.6819 20.3586 23.8799 20.5076C24.0789 20.6566 24.2899 20.7436 24.3269 20.6936C24.4389 20.5826 23.6199 17.5036 23.4829 17.5036C23.4209 17.5036 22.9489 17.2186 22.4399 16.8706L21.5089 16.2496L20.6529 17.0076C20.1439 17.4666 19.6969 17.7516 19.5729 17.7276C19.4489 17.7026 19.0759 17.3176 18.7289 16.8586C18.3929 16.3986 18.0829 16.0266 18.0329 16.0266C17.9959 16.0146 17.6489 16.3986 17.2509 16.8836C16.8669 17.3546 16.4569 17.7516 16.3579 17.7516C16.2709 17.7516 15.8609 17.3546 15.4759 16.8836C15.0789 16.3986 14.7189 16.0146 14.6819 16.0146C14.6319 16.0146 14.2469 16.4366 13.8249 16.9576C13.3539 17.5286 12.9809 17.8766 12.8569 17.8516C12.7449 17.8266 12.3729 17.4046 12.0249 16.9207C11.6899 16.4237 11.3549 16.0266 11.2799 16.0146C11.2179 16.0146 10.8339 16.4366 10.4359 16.9576C9.96493 17.5536 9.64193 17.8766 9.50493 17.8516C9.39393 17.8266 9.02094 17.4046 8.67394 16.9207C8.33794 16.4237 8.01594 16.0146 7.96594 16.0146C7.91594 16.0146 7.53194 16.3247 7.10895 16.6967C6.68695 17.0697 6.24094 17.3796 6.11594 17.3796C5.97994 17.3796 5.66895 17.0947 5.37195 16.6967C5.08595 16.3247 4.83797 16.0146 4.81297 16.0146C4.80097 16.0146 4.65197 16.2007 4.50297 16.4116Z" fill="${fillColor}"/>
					<path d="M22.615 21.1899C22.007 21.7979 21.883 21.8729 21.709 21.7239C21.609 21.6369 21.498 21.5869 21.46 21.6119C21.374 21.7109 23.087 26.8629 23.223 26.8999C23.298 26.9249 23.558 26.8629 23.807 26.7639C24.34 26.5399 24.328 26.7889 23.993 23.4119C23.757 21.0529 23.645 20.4819 23.397 20.4819C23.36 20.4819 23 20.8049 22.615 21.1899ZM19.909 20.7929C19.785 20.9539 19.921 21.4629 20.716 23.7469C21.25 25.2619 21.734 26.5529 21.783 26.6149C21.845 26.6769 22.032 26.6639 22.243 26.5779L22.615 26.4159L21.746 23.7969C20.753 20.8179 20.393 20.2219 19.909 20.7929ZM4.10607 20.8299C3.78407 21.1649 3.75907 21.3019 3.58507 23.1019C3.511 23.9138 3.42831 24.7248 3.33706 25.5349C3.26206 26.0189 3.28706 26.0689 3.64705 26.2549C3.87105 26.3659 4.05705 26.4409 4.08205 26.4159C4.13105 26.3789 4.64006 21.1649 4.64006 20.7559C4.64006 20.396 4.50407 20.4079 4.10607 20.8299ZM6.75007 21.3509C6.04307 21.9719 5.77006 21.9719 5.34807 21.3889C5.16107 21.1279 5.00008 20.9419 5.00008 20.9789C4.87608 21.4999 4.44107 26.7759 4.51607 26.8509C4.56507 26.9129 4.80107 26.9749 5.02507 26.9749L5.43406 26.9999L6.40305 24.0199C6.93605 22.3819 7.35905 21.0039 7.33405 20.9539C7.32105 20.8919 7.06107 21.0779 6.75007 21.3509Z" fill="${fillColor}"/>
				</svg>`
	const favicon = document.querySelector('link[rel="shortcut icon"]')
	favicon.setAttribute(
		'href',
		`data:image/svg+xml;base64,${window.btoa(svg)}`,
	)
}
// Apply the saved theme (or default) as soon as possible
document.addEventListener('DOMContentLoaded', () => {
	window.themeManager.loadSavedTheme()
	runColorMode((dark) => {
		changeFaviconColor('transparent', dark ? 'white' : 'black')
	})
})
class ChristmasLights extends HTMLElement {
	constructor() {
		super()
		this.startSVG = null
		this.segmentSVG = null
		this.endSVG = null
		this.segmentWidth = 0
		this.resizeObserver = null
		this.bulbSVG = null
		this.gap = Number(window.getComputedStyle(this).gap.slice(0, -2))
	}

	connectedCallback() {
		this.startSVG = this.#constructSVG(
			'start-width',
			'start-height',
			'start',
			{ stroke: 'black' },
		)
		this.#drawBulbs('start-bulbs', this.startSVG)
		this.segmentSVG = this.#constructSVG(
			'segment-width',
			'segment-height',
			'segment',
			{ stroke: 'black' },
		)
		this.#drawBulbs('segment-bulbs', this.segmentSVG)
		this.endSVG = this.#constructSVG('end-width', 'end-height', 'end', {
			stroke: 'black',
		})
		this.#drawBulbs('end-bulbs', this.endSVG)
		this.bulbSVG = this.#constructSVG('bulb-width', 'bulb-height', 'bulb', {
			fill: [
				'hsl(var(--bulb-color))',
				'rgb(var(--text))',
				'hsl(42 85% 78%)',
				'hsl(42 85% 78%)',
				'hsl(42 85% 78%)',
			],
		})
		this.bulbSVG.id = 'bulb-svg'
		// Initial render
		this.#render()

		// Recalculate and redraw on window resize
		this.resizeObserver = new ResizeObserver(() => this.#render())
		this.resizeObserver.observe(this)
	}
	#drawBulbs(bulb_attr, parent) {
		const bulbs = JSON.parse(this.getAttribute(bulb_attr))
		for (const bulb of bulbs) {
			const bulbSVG = document.createElementNS(
				'http://www.w3.org/2000/svg',
				'use',
			)
			bulbSVG.setAttribute('href', '#bulb-svg')
			bulbSVG.style.rotate = `${bulb[0]}deg`
			bulbSVG.setAttribute('x', bulb[1])
			bulbSVG.setAttribute('y', bulb[2])
			parent.appendChild(bulbSVG)
		}
	}
	disconnectedCallback() {
		// Cleanup resize observer
		if (this.resizeObserver) {
			this.resizeObserver.disconnect()
			this.resizeObserver = null
		}
	}

	#render() {
		// Clear the container
		this.innerHTML = ''

		// Append the start SVG
		this.appendChild(this.startSVG)

		// Calculate container width and segment width
		const containerWidth = this.offsetWidth
		this.segmentWidth =
			Number.parseInt(this.getAttribute('segment-width'), 10) || 0

		// Ensure segmentWidth is valid
		if (this.segmentWidth <= 0) {
			console.warn('Invalid segment width:', this.segmentWidth)
			return
		}

		// Calculate how many segments fit in the container
		const startWidth = this.startSVG.width.baseVal.value || 0
		const endWidth = this.endSVG.width.baseVal.value || 0
		const numSegments = Math.max(
			0,
			Math.floor(
				(containerWidth - startWidth - endWidth - this.gap * 4) /
					(this.segmentWidth + this.gap),
			) - 1,
		)

		// Log for debugging
		console.log({
			containerWidth,
			segmentWidth: this.segmentWidth,
			startWidth,
			endWidth,
			numSegments,
		})

		// Append the required number of segments
		for (let i = 0; i < numSegments; i++) {
			this.appendChild(this.segmentSVG.cloneNode(true))
		}

		// Append the end SVG
		this.appendChild(this.endSVG)

		// Append the bulb SVG
		this.appendChild(this.bulbSVG)
	}

	#constructSVG(widthAttr, heightAttr, pathAttr, { stroke, fill } = {}) {
		const [width, height, ds] = [
			this.getAttribute(widthAttr),
			this.getAttribute(heightAttr),
			this.getAttribute(pathAttr),
		]

		const svg = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'svg',
		)

		svg.setAttribute('width', width)
		svg.setAttribute('height', height)
		svg.setAttribute('viewBox', `0 0 ${width} ${height}`)
		svg.setAttribute('fill', 'none')
		for (const [index, d] of ds.split(',').entries()) {
			const path = document.createElementNS(
				'http://www.w3.org/2000/svg',
				'path',
			)
			path.setAttribute('d', d)
			if (stroke) {
				path.setAttribute('stroke', 'rgb(var(--text))')
				path.setAttribute('stroke-width', '3')
				path.setAttribute('stroke-dasharray', '500')
				path.setAttribute('stroke-dashoffset', '500')
			} else if (fill[index]) {
				path.setAttribute('fill', fill[index])
			}
			svg.appendChild(path)
		}
		return svg
	}
}

customElements.define('christmas-lights', ChristmasLights)
class GarlandFlourish extends HTMLElement {
	constructor() {
		super()
		this.svg = null
	}

	connectedCallback() {
		const path = this.getAttribute('path')
		const strokeWidth = this.getAttribute('stroke-width')
		const stroke = this.getAttribute('stroke')

		this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
		this.svg.setAttribute('preserveAspectRatio', 'none')
		this.svg.setAttribute('viewBox', '0 0 547 82')
		this.svg.setAttribute('fill', 'none')

		const pathLength = this.calculatePathLength(path)
		const numRepeats = Math.ceil(
			this.calculateContainerWidth() / pathLength,
		)

		const defs = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'defs',
		)
		const group = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'g',
		)
		group.id = 'repeating-path-group'

		for (let i = 0; i < numRepeats; i++) {
			const pathEl = document.createElementNS(
				'http://www.w3.org/2000/svg',
				'path',
			)
			pathEl.setAttribute('d', path)
			pathEl.setAttribute('stroke', stroke)
			pathEl.setAttribute('stroke-width', strokeWidth)
			pathEl.setAttribute('stroke-linecap', 'round')
			pathEl.setAttribute('transform', `translate(${i * pathLength}, 0)`)
			group.appendChild(pathEl)
		}

		defs.appendChild(group)
		this.svg.appendChild(defs)

		const use = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'use',
		)
		use.setAttribute('href', '#repeating-path-group')
		use.setAttribute('x', '0')
		use.setAttribute('y', '0')
		use.setAttribute('width', '100%')
		use.setAttribute('height', '100%')

		this.svg.appendChild(use)
		this.innerHTML = ''
		this.appendChild(this.svg)
	}

	calculatePathLength(pathData) {
		const path = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'path',
		)
		path.setAttribute('d', pathData)
		return path.getTotalLength()
	}

	calculateContainerWidth() {
		return this.parentElement.clientWidth || window.innerWidth
	}
}

customElements.define('garland-flourish', GarlandFlourish)
